<template>
  <div v-if="more.can_action" :class="`design-idea-status form-group w-100 ${status}`" ref="container">
    <!-- confirm -->
    <div v-if="['confirm'].includes(more.can_action)" class="position-relative d-flex">
      <a href="#" @click.stop.prevent="submit('denied')" class="btn btn-outline-light mr-2"><span>Cancel</span></a>
      <a href="#" @click.stop.prevent="submit('doing')" class="btn btn-outline-success"><span>Confirm</span></a>
    </div>

    <!-- doing -->
    <div v-else-if="['doing', 'design-rejected'].includes(more.can_action)" class="position-relative d-flex flex-wrap">
      <div class="w-100">
        <input class="form-control flex-1" :value="designUrl()" @change="toggleDesignUrl($event, 'url')" ref="DesignUrl" placeholder="Design url" />
      </div>
      <ButtonUpload :config="{ multiple: true, uploadFromUrl: false, group: false }" v-model="data.designs" @change="toggleDesignUrl($event, 'file')" class="flex-1 mt-2 mr-2"></ButtonUpload>
      <a href="#" @click.stop.prevent="submit('design-review')" class="btn btn-outline-success mt-2">
        <span>Confirm</span>
      </a>
      <ThumbnailPreview :value="designFile()" @changeValue="data.designs = $event" class="design-thumbnail mt-1" editable></ThumbnailPreview>
      <UploadArtwork :value="artworkFile()" @change="changeArtworkFiles"></UploadArtwork>
    </div>

    <!-- design-review -->
    <div v-else-if="['design-review'].includes(more.can_action)" class="position-relative d-flex flex-wrap">
      <a href="#" @click.stop.prevent="submit('create-mockup')" class="btn btn-outline-success mr-2"><span>Create Mockup</span></a>
      <a href="#" @click.stop.prevent="submit('create-demo')" class="btn btn-outline-primary"><span>Create Demo</span></a>
      <a href="#" @click.stop.prevent="submit('design-rejected')" class="btn btn-outline-light mt-2"><span>Reject</span></a>
    </div>

    <!-- create-demo -->
    <div v-else-if="['create-demo', 'demo-rejected'].includes(more.can_action)" class="position-relative d-flex">
      <a href="#" @click.stop.prevent="submit('design-rejected')" class="btn btn-outline-light mr-2 pl-1 pr-1"><span>Reject</span></a>
      <a href="#" @click.stop.prevent="submit('demo-review')" class="btn btn-outline-success mr-2 pl-1 pr-1"><span>Demo Review</span></a>
    </div>

    <!-- demo-review -->
    <div v-else-if="['demo-review'].includes(more.can_action)" class="position-relative d-flex flex-wrap">
      <a href="#" @click.stop.prevent="submit('demo-rejected')" class="btn btn-outline-success mr-2"><span>Reject</span></a>
      <a href="#" @click.stop.prevent="submit('completed')" class="btn btn-outline-primary"><span>Completed</span></a>
    </div>

    <!-- create-mockup -->
    <div v-else-if="['create-mockup', 'mockup-rejected', 'listing'].includes(more.can_action)">
      <template v-for="(mockups, index) in data.mockups" :key="index">
        <div v-if="mockups.deleted != 1" class="position-relative d-flex flex-wrap mb-2">
          <Select class="mb-2" source="term/search" v-model="data.mockups[index].term_id" @change="setMockupTerm(index)" placeholder="Category" ref="MockupTermId"></Select>
          <div class="w-100">
            <input class="form-control flex-1" :value="mockupUrl(index)" @change="toggleMockupUrl($event, index, 'url')" placeholder="Mockup url" />
          </div>
          <ButtonUpload :config="{ multiple: true, uploadFromUrl: false, group: false }" v-model="data.mockups[index].attachments" @change="toggleMockupUrl($event, index, 'file')" class="flex-1 mt-2"></ButtonUpload>
          <a href="#" @click.stop.prevent="deleteMockup(index)" class="btn btn-outline-danger ml-2 mt-2"><span>Delete</span></a>
          <ThumbnailPreview :value="mockupFile(index)" @changeValue="data.mockups[index].attachments = $event" class="design-thumbnail mt-1" editable></ThumbnailPreview>
        </div>
      </template>
      <div class="position-relative form-group d-flex flex-wrap">
        <a href="#" @click.stop.prevent="submit('design-rejected')" class="btn btn-outline-light mr-2"><span>Reject</span></a>
        <a href="#" @click.stop.prevent="submit('mockup-review')" class="btn btn-outline-success mr-2"><span>Confirm</span></a>
        <a href="#" @click.stop.prevent="submit('completed')" class="btn btn-outline-success mr-2"><span>Completed</span></a>
        <a href="#" @click.stop.prevent="addMockup()" class="btn btn-outline-light mt-2"><span>Add more</span></a>
      </div>
    </div>

    <!-- mockup-review -->
    <template v-else-if="['mockup-review'].includes(more.can_action)">
      <div v-for="(mockup, index) in Object.values(mockups).filter((item) => item.latest == 1)" :key="index" class="position-relative">
        <label class="font-weight-bold">{{ terms?.[mockup?.term_id]?.name || '[No name]' }}</label>
        <div class="position-relative form-group d-flex align-items-center">
          <input class="form-control has-tip" type="text" v-model="mockup.title" placeholder="Title" data-title="Title" /><small :class="`${String(mockup.title).length > 140 ? 'text-danger' : ''} ml-2`">{{ String(mockup.title).length }}/140</small>
        </div>
        <div class="position-relative form-group d-flex align-items-center">
          <Select class="has-tip" v-model="mockup.tags" multiple taggable placeholder="Tags" data-title="Tags"></Select><small :class="`${Object.keys(mockup.tags).length > 13 ? 'text-danger' : ''} ml-2`">{{ Object.keys(mockup.tags).length }}/13</small>
        </div>
        <div class="position-relative form-group d-flex">
          <a href="#" @click.stop.prevent="submit('mockup-rejected', { term_id: mockup.term_id })" class="btn btn-outline-light mr-2"><span>Denied</span></a>
          <a href="#" @click.stop.prevent="submit('listing', { term_id: mockup.term_id })" class="btn btn-outline-success"><span>Confirm</span></a>
        </div>
      </div>
    </template>

    <!-- completed -->
    <div v-else-if="['completed'].includes(more.can_action)" class="position-relative d-flex flex-wrap justify-content-center">
      <a href="#" @click.stop.prevent="submit('design-rejected')" class="btn btn-outline-light mr-2"><span>Reject Design</span></a>
      <a href="#" @click.stop.prevent="submit('demo-rejected')" class="btn btn-outline-light mr-2"><span>Reject Demo</span></a>
      <a href="#" @click.stop.prevent="submit('mockup-rejected')" class="btn btn-outline-light mt-2 mr-2"><span>Reject Mockup</span></a>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
import ButtonUpload from '@/components/ButtonUpload.vue'
import ThumbnailPreview from '@/components/ThumbnailPreview.vue'
import UploadArtwork from '@/components/UploadArtwork.vue'

export default {
  components: {
    ButtonUpload,
    ThumbnailPreview,
    UploadArtwork
  },
  data() {
    return {
      data: {
        designs: {},
        mockups: [
          {
            attachments: {},
            title: '',
            tags: []
          }
        ]
      }
    }
  },
  computed: {
    status() {
      return this.config?.status
    },
    mockups() {
      return Object.assign({}, this.config?.mockups)
    },
    terms() {
      let terms = {}
      Object.values(this.config?.terms || []).forEach((item) => {
        terms[item.id] = item
      })
      return terms
    },
    more() {
      return this.config?.data?.more || this.config?.more || {}
    },
    ideaIds() {
      if (this.config?.designIds && this.config.designIds.length > 0) return this.config.designIds
      if (this.config?.id) return [this.config.id]
      return []
    }
  },
  methods: {
    designUrl() {
      return this.data?.designs?.[0] || ''
    },
    designFile() {
      let files = {}
      for (const [key, item] of Object.entries(this.data.designs || {})) {
        if (!['front', 'back', 'cut'].includes(key) && _.isObjectLike(item)) {
          files[key] = item
        }
      }
      return files
    },
    artworkFile() {
      return this.data.artworks || {}
    },
    mockupUrl(index) {
      return this.data.mockups?.[index]?.attachments?.[0] || ''
    },
    mockupFile(index) {
      return this.$util.filter(this.data.mockups[index].attachments || [], ({ item }) => {
        return _.isObjectLike(item)
      })
    },
    changeDesignFiles(values) {
      for (const key of Object.keys(this.data.designs || {})) {
        if (!['front', 'back', 'cut'].includes(key)) {
          delete this.data.designs[key]
        }
      }
      for (const [key, val] of Object.entries(values)) {
        this.data.designs[key] = val
      }
    },
    changeArtworkFiles(values) {
      this.data.artworks = Object.assign({}, values)
    },
    toggleDesignUrl(e, input) {
      if (input == 'url') {
        if (Object.keys(this.data.designs).length > 1 || (Object.keys(this.data.designs).length == 1 && this.data.designs[0] == undefined)) {
          if (confirm('File already exists. Do you want to delete?') == true) {
            this.data.designs = {
              0: e.currentTarget.value
            }
          }
        } else {
          this.data.designs = {
            0: e.currentTarget.value
          }
        }
      } else {
        if (this.data.designs[0] != undefined) {
          delete this.data.designs[0]
        }
      }
    },
    toggleMockupUrl(e, index, input) {
      if (input == 'url') {
        if (Object.keys(this.data.mockups[index].attachments).length > 1 || (this.data.mockups[index].attachments[0] == undefined && Object.keys(this.data.mockups[index].attachments).length > 0)) {
          if (confirm('File already exists. Do you want to delete?') == true) {
            this.data.mockups[index].attachments = {
              0: e.currentTarget.value
            }
          }
        } else {
          this.data.mockups[index].attachments = {
            0: e.currentTarget.value
          }
        }
      } else {
        if (this.data.mockups[index].attachments[0] != undefined) {
          delete this.data.mockups[index].attachments[0]
        }
      }
    },
    addMockup() {
      this.data.mockups.push({
        attachments: {},
        title: '',
        tags: []
      })
    },
    deleteMockup(index) {
      this.data.mockups[index].deleted = 1
      if (Object.values(this.data.mockups).filter((item) => item.deleted != 1).length < 1) {
        this.data.mockups.push({
          attachments: {},
          title: '',
          tags: []
        })
      }
    },
    setMockupTerm(index) {
      if (this.data.mockups.filter((item) => (item.term_id || null) == this.data.mockups[index].term_id).length > 1 && this.data.mockups[index].term_id != '') {
        alert('Category must be unique!')
        this.data.mockups[index].term_id = ''
      }
    },
    submit(status, args) {
      args = Object.assign(
        {
          confirm: 0,
          term_id: ''
        },
        args
      )
      if (['mockup-rejected', 'listing'].indexOf(status) != -1) {
        args = Object.assign(args, this.mockups[args.term_id || 0])
      }

      let data = Object.assign(
        {},
        this.data,
        {
          mockups: Object.values(this.data.mockups).filter((item) => item.deleted != 1)
        },
        args,
        {
          status: status
        }
      )
      if (this.config?.id) {
        this.$util
          .post(`design-idea/update-status/${this.config?.id}`, data, this.$refs.container)
          .then((response) => {
            if (response.status == 'success') {
              this.$emit('submitStatus', response.data)
              this.$emitter.emit('TableList.Refresh')
              this.data.designs = {}
              this.data.mockups = [
                {
                  attachments: {},
                  title: '',
                  tags: []
                }
              ]
              this.data.term_id = ''
            } else if (response.confirm == 1) {
              if (window.confirm('The current mockup will replace the previous version!') == true) {
                this.submit(status, (args = Object.assign(args, { confirm: 1 })))
              }
            } else {
              console.log(response)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else if (this.ideaIds.length > 0) {
        this.submitMultiple(status, data)
      }
    },
    async submitMultiple(status, data) {
      let successIds = []
      let failedItems = []
      try {
        await Promise.all(
          this.ideaIds.map(async (id) => {
            try {
              const response = await this.$util.post(`design-idea/update-status/${id}`, data, this.$refs.container)
              if (response?.status == 'success') {
                successIds.push(id)
              } else {
                failedItems.push({ id, message: response?.message || 'Update failed' })
              }
            } catch (e) {
              failedItems.push({ id, message: e.message || 'Update failed' })
            }
          })
        )
        this.$emit('changeValue', { successIds, failedItems })
        this.$emitter.emit('TableList.Refresh')
        this.data.designs = {}
        this.data.mockups = [{ attachments: {}, title: '', tags: [] }]
        this.data.term_id = ''
      } catch (error) {
        console.error(error)
      }
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.design-idea-status {
  &.doing,
  &.denied,
  &.create-mockup {
    .dropdown-toggle {
      width: 100%;
    }
  }
  small {
    min-width: 36px;
  }
}
</style>
